module.exports = __webpack_public_path__ + "img/logo.a12a2f5f.png";